export enum SyneriseFormEvent {
  IDENTIFY = 'identify',
  RESET_PASSWORD = 'reset-password',
  ADDRESS_CREATE = 'address.create',
  ADDRESS_EDIT = 'address.edit',
  INVOICE_ADDRESS_CREATE = 'invoice-address.create',
  INVOICE_ADDRESS_EDIT = 'invoice-address.edit',
  DELIVERY_AREA_CHECK = 'delivery-area.check',
  REBATE_CODE_ADD = 'rebate-code.add',
  LOGIN = 'login',
  REGISTRATION = 'registration',
  PROFILE_EDIT = 'profile.edit',
  DELETE_ACCOUNT = 'delete-account',
}

export type SRFields =
  | 'lastname'
  | 'firstname'
  | 'email'
  | 'birthdate'
  | 'phone'
  | 'city'

export type SRFormData = Record<
  string,
  string | number | boolean | undefined | null
>
export type SRFieldMapping = Partial<Record<SRFields, keyof SRFormData>>

type SyneriseGetCurrentClientResult = {
  _result: {
    uuid: string
  }
}

export interface SRInterface {
  event: {
    sendFormData: (
      event: string,
      formData: SRFormData,
      fieldMapping?: SRFieldMapping
    ) => void
    trackCustomEvent: (event: string, data: unknown, name: string) => void
    pageVisit: (data: Record<string, unknown>) => Promise<void>
    recommendationView: (
      data: RecommendationViewEventData,
      label?: string
    ) => void
    recommendationClick: (
      data: RecommendationClickEventData,
      label?: string
    ) => void
  }
  client: {
    setUuidAndIdentityHash: (uuid: string, data: unknown) => void
    getIdentityHash: () => string
    hashIdentity: (email: string) => string
    getCurrentClient: () => SyneriseGetCurrentClientResult
  }
  dynamicContent: {
    get: () => Promise<void>
  }
}

export interface SyneriseTCInterface {
  uuid: string
}

declare global {
  interface Window {
    SR: SRInterface
    SyneriseTC?: SyneriseTCInterface
  }
}

// Synerise recommendations

export type SyneriseCampainRecommendationApiResponse = {
  data: {
    data: {
      attributes: {
        product_id: string
      }
    }[]
    extras: {
      correlationId: string | null
    }
  }
}

export type RecommendationMetadataType = {
  correlationId: string | null
  campaignId: string
}

type RecommendationEventData = RecommendationMetadataType & {
  [key: string]: string | string[]
}

export type RecommendationViewEventData = RecommendationEventData & {
  items: string[]
}

export type RecommendationClickEventData = RecommendationEventData & {
  item: string
}

export type SyneriseCampaignRecommendationQueryParams = {
  clientUUID?: string
  itemId?: string | string[]
  itemsSourceType?: 'aggregate' | 'expression'
  itemsSourceId?: string
  itemIdExcluded?: string | string[]
  additionalFilters?: string
  filtersJoiner?: 'AND' | 'OR' | 'REPLACE'
  additionalElasticFilters?: string
  elasticFiltersJoiner?: 'AND' | 'OR' | 'REPLACE'
  displayAttribute?: string | string[]
  includeContextItems?: boolean
  params?: Record<string, string>
}

export interface SyneriseIdentity {
  email: string
  firstName?: string
  lastName?: string
  dateOfBirth?: string
}
